import { getProductDetailParam, ProductDetail } from '@dh-io-emh/commerce-api/src/models/product';
import Vehicle from '../models/vehicle.model';
import { StockProduct } from '@dh-io-pls/pls-store';

export function productDetailToStockProduct<T extends Vehicle | ProductDetail>(product: T): StockProduct {
  const code = getProductDetailParam(product, 'code')!;
  const badges = getProductDetailParam(product, 'badges')!;
  /*
    To add in order to respect the StockProduct structure in node_modules/@dh-io-pls/pls-store/dist/index.d.ts
    dcpProductType: {           --> N/A
        name: string;
    };
    price: {
        value: number;          --> pricing.listPriceB2X.value
        formattedValue: string; --> pricing.listPriceB2X.formattedValue
    };
    listPrice?: {
        value: number;          --> pricing.listPriceB2X.value
        formattedValue: string; --> pricing.listPriceB2X.formattedValue
    };
   */

  return { ...product, code, badges };
}
